(function () {
  const THRESHOLD = 15000;
  const ATTRIBUTE_NAME = 'Goodie Bag Cadou';

  let running = false;
  let timer = null;

  function scheduleUpdate(delay = 300) {
    clearTimeout(timer);

    timer = setTimeout(() => {
      updateGoodieBag();
    }, delay);
  }

function createGoodieElement() {
  const element = document.createElement('div');

  element.className = 'goodie-bag-wrapper';
  element.setAttribute('data-goodie-bag', '');

  element.innerHTML = `
    <div class="goodie-bag-progress" data-goodie-progress>
      <div class="goodie-bag-progress__text">
        🎁 Mai ai <strong data-goodie-remaining></strong> până primești <strong>Goodie Bag Cadou</strong> 🎁
      </div>

      <div class="goodie-bag-progress__bar">
        <div class="goodie-bag-progress__fill" data-goodie-progress-fill></div>
      </div>
    </div>

    <div class="goodie-bag-gift" data-goodie-gift style="display:none;">
      <div class="goodie-bag-gift__icon">🎁</div>

      <div class="goodie-bag-gift__content">
        <strong>Goodie Bag Cadou</strong>
        <span>Cadou inclus la comenzi de minimum 150 lei</span>
      </div>

      <div class="goodie-bag-gift__price">
        GRATUIT
      </div>
    </div>
  `;

  return element;
}

  function insertGoodieBag() {
    if (document.querySelector('[data-goodie-bag]')) {
      return;
    }

    /*
     * Îl punem în drawer imediat după bara de transport gratuit.
     */
    const shippingBar =
      document.querySelector('.cart-footer [data-free-shipping-progress]');

    if (shippingBar) {
      shippingBar.insertAdjacentElement(
        'afterend',
        createGoodieElement()
      );

      return;
    }

    /*
     * Fallback dacă bara de transport nu există.
     */
    const drawerBottom =
      document.querySelector('.cart-footer .drawer-bottom');

    if (drawerBottom) {
      drawerBottom.insertAdjacentElement(
        'beforebegin',
        createGoodieElement()
      );
    }
  }

  function removeGoodieBag() {
    document.querySelectorAll('[data-goodie-bag]').forEach((element) => {
      element.remove();
    });
  }

  

  async function updateGoodieBag() {
    if (running) return;

    running = true;

    try {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      });

      const cart = await response.json();

      const subtotal = cart.total_price;
const eligible = subtotal >= THRESHOLD;

/*
 * Drawer
 */
insertGoodieBag();

document.querySelectorAll('[data-goodie-bag]').forEach((element) => {
  const progress = element.querySelector('[data-goodie-progress]');
  const gift = element.querySelector('[data-goodie-gift]');
  const remaining = element.querySelector('[data-goodie-remaining]');
  const fill = element.querySelector('[data-goodie-progress-fill]');

  if (eligible) {
    if (progress) progress.style.display = 'none';
    if (gift) gift.style.display = '';
  } else {
    const remainingAmount = Math.max(THRESHOLD - subtotal, 0);
    const progressPercent = Math.min((subtotal / THRESHOLD) * 100, 100);

    if (progress) progress.style.display = '';
    if (gift) gift.style.display = 'none';

    if (remaining) {
      remaining.textContent =
        (remainingAmount / 100).toLocaleString('ro-RO', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + ' lei';
    }

    if (fill) {
      fill.style.width = progressPercent + '%';
    }
  }
});

/*
 * Pagina /cart
 */
document.querySelectorAll('[data-goodie-bag-cart]').forEach((element) => {
  element.style.display = eligible ? '' : 'none';
});
      const currentAttribute =
        cart.attributes &&
        cart.attributes[ATTRIBUTE_NAME];

      if (eligible && currentAttribute !== 'DA') {
        await fetch('/cart/update.js', {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },

          body: JSON.stringify({
            attributes: {
              [ATTRIBUTE_NAME]: 'DA'
            }
          })
        });
      }

      if (!eligible && currentAttribute) {
        await fetch('/cart/update.js', {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },

          body: JSON.stringify({
            attributes: {
              [ATTRIBUTE_NAME]: ''
            }
          })
        });
      }

    } catch (error) {
      console.error('Goodie Bag:', error);

    } finally {
      running = false;
    }
  }

  /*
   * Prima încărcare
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scheduleUpdate(100);
    });
  } else {
    scheduleUpdate(100);
  }

  /*
   * Detectăm când Shopify/theme reconstruiește drawer-ul.
   */
  const observer = new MutationObserver(() => {
    scheduleUpdate(350);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /*
   * Backup pentru cantitate/remove.
   */
  document.addEventListener('click', (event) => {
    if (
      event.target.closest('.quantity__button') ||
      event.target.closest('mini-cart-remove-button') ||
      event.target.closest('cart-remove-button') ||
      event.target.closest('[name="plus"]') ||
      event.target.closest('[name="minus"]')
    ) {
      scheduleUpdate(900);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[name="updates[]"]')) {
      scheduleUpdate(900);
    }
  });

})();